import component from "containers/StaticPages/pages/Careers";

export default {
  key: "powur-careers",
  title: "Careers",
  path: "/:user?/careers",
  pageName: "Careers",
  linkTarget: "/careers",
  component,
};
